import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';
const country = process.env.REACT_APP_COUNTRY;
let languaje = '';

export default async function getInvoices(month, year) {
  if (country === 'MX') {
    languaje = '0';
  } else {
    languaje = '1';
  }

  let url = `${webservice}/GetInvoices?Axo=${year}&Mes=${month}&Idioma=${languaje}`;
  let response = {};

  await superagent
    .get(url)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        typeMessage: 'error',
        message: 'Error',
      };
      response = resp;
    });

  return response;
}
